import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';

import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { MatCheckboxModule } from '@angular/material/checkbox';

import { DcbmServiceFormAutoCompleteModule } from '../../chipList/DcbmService/DcbmService.module';

import { ParameterListActServiceFormComponent } from './ParameterListActService.component';

@NgModule({
  declarations: [ParameterListActServiceFormComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,

    MatInputModule,
    MatSelectModule,

    MatCheckboxModule,

    DcbmServiceFormAutoCompleteModule
  ],
  exports: [
    ParameterListActServiceFormComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,

    MatInputModule,
    MatSelectModule,

    MatCheckboxModule,

    DcbmServiceFormAutoCompleteModule
  ]
})
export class ParameterListActServiceFormModule {}
